import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core" ;
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";

declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_category_line_template extends vnTemplate{


    protected getTemplateHtml(): string{

        return `<div data-bind="attr: {id: idChart}, style: {width: cssWidth, height: cssHeight, display: (show() == true) ? 'block': 'none' }"></div>`;
    }

    public getTemplateName(): string{
        return "amCharts_v4_category_line_template";
    }

    protected buildViewModel(): any{

        let _this = this;
        return  {
            idChart: ko.observable("chartDiv_" + _this.idElement),
            category: ko.observable(""),
            cssWidth: ko.observable("98%"),
            cssHeight: ko.observable("300px"),
            xAxisRotation: ko.observable(0),
            xAxisFontSize: ko.observable(10),
            seriesTooltipFormat: ko.observable("{name}: [bold]{valueY}[/]"),
            show: ko.observable(false),
            yaxis: ko.observableArray([]),
            ranges: ko.observableArray([]),
        };
    }

    protected getMainElementClasses(): Array<string>{
        return ["graph"];
    }

    public setXAxisRotation(rotation: number): void {
        this.getTemplateViewModel().xAxisRotation(rotation);
    }


    public setXAxisFontSize(rotation: number): void {
        this.getTemplateViewModel().xAxisFontSize(rotation);
    }

    public setSeriesTooltipFormat(tooltipFormat: string): void {
        this.getTemplateViewModel().seriesTooltipFormat(tooltipFormat);
    }


    public setCategory(category) {
        this.getTemplateViewModel().category(category);
    }

    public setYaxis(axis) {
        this.getTemplateViewModel().yaxis(axis);
    }

    public setRanges(ranges) {
        this.getTemplateViewModel().ranges(ranges);
    }

    public show(): void {
        this.getTemplateViewModel().show(true);
    }

    public hide(): void {
        this.getTemplateViewModel().show(false);
    }

    //public drawChart(data, labels, axes, seriess, textColor){
    public drawChart(chartData) {

        let _this = this;

        /* Chart code */
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);

        //remove logo
        if(chart.logo){

            chart.logo.disabled = true;
        }

        // Increase contrast by taking evey second color
        //chart.colors.step = 2;

        // Add data
        chart.data = chartData;


        // Create axes
        let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());

        xAxis.dataFields.category = this.getTemplateViewModel().category();

        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.labels.template.rotation = this.getTemplateViewModel().xAxisRotation();
        xAxis.renderer.labels.template.verticalCenter = "middle";
        xAxis.renderer.labels.template.fontSize = this.getTemplateViewModel().xAxisFontSize();
        xAxis.renderer.minGridDistance = 20;

        let yAxis = [];
        for (let axis of this.getTemplateViewModel().yaxis()) {

            if (typeof yAxis[axis.axis] === 'undefined') {
                yAxis[axis.axis] = chart.yAxes.push(new am4charts.ValueAxis());
            }

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = axis.field;
            series.dataFields.categoryX = this.getTemplateViewModel().category();
            series.strokeWidth = 2;
            series.fill = am4core.color(axis.color);
            series.stroke = am4core.color(axis.color);
            series.yAxis = yAxis[axis.axis];
            series.name = axis.name;
            series.tooltipText = this.getTemplateViewModel().seriesTooltipFormat();
            series.tensionX = 0.8;
            series.showOnInit = true;

            let interfaceColors = new am4core.InterfaceColorSet();


            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.strokeWidth = 2;

            yAxis[axis.axis].renderer.line.strokeOpacity = 1;
            yAxis[axis.axis].renderer.line.strokeWidth = 2;
            yAxis[axis.axis].renderer.line.stroke = series.stroke;
            yAxis[axis.axis].renderer.labels.template.fill = series.stroke;
            yAxis[axis.axis].renderer.opposite = axis.opposite;
        }

        for (let range of this.getTemplateViewModel().ranges()) {

            let addrange = xAxis.axisRanges.create();
            addrange.category = range.category;
            addrange.endCategory = range.endCategory;
            addrange.axisFill.fill = am4core.color(range.fill);
            addrange.axisFill.fillOpacity = range.fillOpacity;
            addrange.locations.category = range.locationsCategory;
            addrange.locations.endCategory = range.locationsEndCategory;
        }

        // Add legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "right";
        chart.legend.maxWidth = 200;
        chart.legend.labels.template.truncate = false;
        chart.legend.labels.template.wrap = true;

        // Add cursor
        chart.cursor = new am4charts.XYCursor();

    }
}



// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_category_line_template.ts